import { Toast } from 'antd-mobile';
import { readerImage } from '@/asset/js/utils';
import {
  jungleExpeditionInfo,
  jungleExpeditionTreasureInfo,
  jungleExpeditionUpdateTreasure,
  jungleExpeditionRemindTip,
  jungleExpeditionDrawInfo,
  jungleExpeditionUpdateDraw,
  jungleExpeditionRank,
  jungleExpeditionDrawHistory,
  jungleExpeditionFloatScreen,
  jungleExpeditionTaskInfo,
  jungleExpeditionPoolInfo,
  jungleExpeditionWinList,
} from '@/services/activity';

// import { MocKInfo, RecordMock, MockTreatureInfo, MockTip, MockDrawInfo, MockTaskList, MockRankList, MockPoolInfo, MockWinList } from '../mock';

export default {
  namespace: 'activityJungleExpedition',
  state: {
    endTime: 0,
    title: '',
    titleUrl: '',
    rules: '',
    ranks: [],
    daysInfo: [],
    selfInfo: {},
    receiveRewards: [],
    sendRewards: [],
    lastId: '',
    isMore: false,
    status: 0,
    pageNum: 1,
    pageSize: 20,
    detailsMap: [],
    countDown: 0,
    wordArtUrl: '',
    synthesisCount: 0,
    synthesisFinishCount: 0,
    itemList: [],
    challengeRewards: [],
    drawButtons: [],
    ticketsNum: 0,
    drawItems: [],
    taskList: [],
    roomId: '',
    showTip: false,
    synthesisCountTip: 0,
    broadcasts: [],
    openState: 0,
    retainCatchCount: 0,
    activityId: '',
    treasureBoxDailyRewards: [],
    treasureBoxTotalRewards: [],
    dailyRewards: [],
    totalRewards: [],
    limitedGifts: [],
    progress: 0,
    personalState: 0,
    prizePool: '',
    freeGifts: [],
    predicateCoins: 0,
    isWinMore: false,
    winPageInfo: {
      pageNum: 1,
      pageSize: 20,
      isMore: false,
    },
    anchorStatus: 0, // 主播身份
    winList: [],
    dayCountDown: 0,
    dayGifts: [],
    dailyTreasureMapCount: 0,
    wholeJungleTreasureThreshold: 0,
    personalDelta: 0,
    limitedGiftRate: '',
    activityId: '',
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        endTime: 0,
        activityId: payload.activityId || '',
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        rules: payload.rules || '',
        status: payload.status || 0,
        countDown: payload.countDown || 0,
        wordArtUrl: payload.wordArtUrl || '',
        roomId: payload.roomId || '',
        daysInfo: payload.daysInfo || [],
        treasureBoxDailyRewards: payload.treasureBoxDailyRewards || [],
        treasureBoxTotalRewards: payload.treasureBoxTotalRewards || [],
        dailyRewards: payload.dailyRewards || [],
        totalRewards: payload.totalRewards || [],
        limitedGifts: payload.limitedGifts || [],
        anchorStatus: payload.anchorStatus || 0,
      };
    },
    updateTreasureInfo(state, { payload }) {
      return {
        ...state,
        synthesisCount: payload.synthesisCount || 0,
        synthesisFinishCount: payload.synthesisFinishCount || 0,
        itemList: payload.itemList || [],
        challengeRewards: payload.challengeRewards || [],
        dayCountDown: payload.countDown || 0,
        dayGifts: payload.limitedGifts || [],
        dailyTreasureMapCount: payload.dailyTreasureMapCount || 0,
        limitedGiftRate: payload.limitedGiftRate || '',
      };
    },
    updateDrawInfo(state, { payload }) {
      return {
        ...state,
        drawButtons: payload.drawButtons || [],
        ticketsNum: payload.ticketsNum || 0,
        drawItems: payload.drawItems || [],
      };
    },
    updateTicketInfo(state, { payload }) {
      return {
        ...state,
        ticketsNum: payload.ticketsNum || 0,
      };
    },
    updateTaskInfo(state, { payload }) {
      return {
        ...state,
        taskList: payload.taskList || [],
      };
    },
    updateTipInfo(state, { payload }) {
      return {
        ...state,
        showTip: payload.showTip || false,
        synthesisCountTip: payload.synthesisCount || 0,
      };
    },
    updateBroadcasts(state, { payload }) {
      return {
        ...state,
        broadcasts: payload.data || [],
      };
    },
    updateSynthesisCount(state, { payload }) {
      return {
        ...state,
        synthesisCount: 0,
      };
    },
    updatePoolInfo(state, { payload }) {
      return {
        ...state,
        openState: payload.openState || 0,
        progress: payload.progress || 0,
        personalState: payload.personalState || 0,
        prizePool: payload.prizePool || 0,
        freeGifts: payload.freeGifts || [],
        predicateCoins: payload.predicateCoins || 0,
        wholeJungleTreasureThreshold: payload.wholeJungleTreasureThreshold || 0,
        personalDelta: payload.personalDelta || 0,
      };
    },
    updateRemianCount(state, { payload }) {
      return {
        ...state,
        retainCatchCount: payload.retainCatchCount || 0,
      };
    },
    updateList(state, { payload }) {
      let list = payload.force ? [] : [...state.ranks];
      let selfInfo = {};
      let lastId = '';
      if (payload.ranks && payload.ranks.length) {
        list = [...list, ...payload.ranks];
        lastId = payload.ranks[payload.ranks.length - 1].userId;
      }
      if (payload.selfInfo && payload.selfInfo.userId) {
        selfInfo = payload.selfInfo;
      }
      return {
        ...state,
        selfInfo: selfInfo,
        ranks: list,
        lastId,
      };
    },
    updateDetailList(state, { payload }) {
      let newList = payload.force ? [] : [...state.detailsMap];
      let isMore = false;
      if (payload.records && payload.records.length) {
        newList = [...newList, ...payload.records];
        isMore = payload.records.length >= state.pageSize;
      }
      return {
        ...state,
        detailsMap: newList,
        pageNum: payload.pageNum || 1,
        isMore: isMore || false,
      };
    },
    updateWinList(state, { payload }) {
      let newList = payload.force ? [] : [...state.winList];
      let isMore = false;
      if (payload.records && payload.records.length) {
        newList = [...newList, ...payload.records];
        isMore = payload.records.length >= state.winPageInfo.pageSize;
      }
      return {
        ...state,
        winList: newList,
        isWinMore: isMore,
        winPageInfo: {
          pageNum: payload.pageNum || 1,
          pageSize: state.winPageInfo.pageSize || 20,
          isMore,
        },
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(jungleExpeditionInfo, payload);
      // yield put({
      //   type: 'updateInfo',
      //   payload: MocKInfo,
      // });
      // return true;
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateInfo',
        payload: data,
      });
      return true;
    },
    *getTreasureInfo({ payload }, { call, put }) {
      const { error, data } = yield call(jungleExpeditionTreasureInfo, payload);
      // yield put({
      //   type: 'updateTreasureInfo',
      //   payload: MockTreatureInfo,
      // });
      // return true;
      if (error || !data) {
        yield put({
          type: 'updateTreasureInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateTreasureInfo',
        payload: data,
      });
      return true;
    },
    *getDrawInfo({ payload }, { call, put }) {
      // 联调时需要改变datas为data。注意注意
      // const { error, datas } = yield call(jungleExpeditionDrawInfo, payload);
      // const data = MockDrawInfo;
      const { error, data } = yield call(jungleExpeditionDrawInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateDrawInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      // 处理抽奖的图片大小
      if (data && Array.isArray(data.drawItems)) {
        for (let i = 0; i < data.drawItems.length; i++) {
          // 如果不存在图片，就跳过，防止因为图片没配置导致页面报错加载不出页面问题
          if (!data.drawItems[i].image) {
            continue;
          }
          const { width, height } = yield readerImage(data.drawItems[i].image);
          let w = 60;
          let h = 60;
          let t = 10;
          if (width > height) {
            h = (height / width) * w;
            t = (59 - h) / 2 + t;
          } else if (width < height) {
            w = (width / height) * h;
          } else {
            w = 60;
            h = 60;
          }
          data.drawItems[i].w = w;
          data.drawItems[i].h = h;
          data.drawItems[i].t = t;
        }
      }
      yield put({
        type: 'updateDrawInfo',
        payload: data,
      });
      return true;
    },
    *getTaskInfo({ payload }, { call, put }) {
      const { error, data } = yield call(jungleExpeditionTaskInfo, payload);
      // yield put({
      //   type: 'updateTaskInfo',
      //   payload: MockTaskList,
      // });
      // return true;
      if (error || !data) {
        yield put({
          type: 'updateTaskInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateTaskInfo',
        payload: data,
      });
      return true;
    },
    *getPoolInfo({ payload }, { call, put }) {
      const { error, data } = yield call(jungleExpeditionPoolInfo, payload);
      // yield put({
      //   type: 'updatePoolInfo',
      //   payload: MockPoolInfo,
      // });
      // return true;
      if (error || !data) {
        yield put({
          type: 'updatePoolInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updatePoolInfo',
        payload: data,
      });
      return {
        success: true,
        data,
      };
    },
    *getList({ payload }, { call, put, select }) {
      const { lastId } = yield select(state => state.activityJungleExpedition);
      const { error, data } = yield call(jungleExpeditionRank, { ...payload, lastId: payload.force ? '' : lastId, force: undefined });
      // yield put({
      //   type: 'updateList',
      //   payload: { ...MockRankList, force: payload.force },
      // });
      // return true;
      if (error || !data) {
        yield put({
          type: 'updateList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateList',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *clearList({ payload }, { call, put }) {
      yield put({
        type: 'updateList',
        payload: { force: true },
      });
    },
    *getDetailList({ payload }, { call, put, select }) {
      const { pageNum, pageSize } = yield select(state => state.activityJungleExpedition);
      const { error, data } = yield call(jungleExpeditionDrawHistory, {
        ...payload,
        pageNum: payload.force ? 1 : pageNum,
        pageSize: pageSize,
        force: undefined,
      });
      // yield put({
      //   type: 'updateDetailList',
      //   payload: { ...RecordMock, pageNum: payload.force ? 2 : pageNum + 1, pageSize, force: payload.force },
      // });
      // return true;
      if (error || !data) {
        yield put({
          type: 'updateDetailList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateDetailList',
        payload: { ...data, pageNum: payload.force ? 2 : pageNum + 1, pageSize, force: payload.force },
      });
      return true;
    },
    *getTipInfo({ payload }, { call, put }) {
      const { error, data } = yield call(jungleExpeditionRemindTip, payload);
      // yield put({
      //   type: 'updateTipInfo',
      //   payload: MockTip,
      // });
      // return {
      //   success: true,
      //   data: MockTip,
      // };
      if (error || !data) {
        yield put({
          type: 'updateTipInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateTipInfo',
        payload: data,
      });
      return {
        success: true,
        data,
      };
    },
    *getBroadcast({ payload }, { call, put }) {
      const { error, data } = yield call(jungleExpeditionFloatScreen, payload);
      if (error || !data) {
        yield put({
          type: 'updateBroadcasts',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateBroadcasts',
        payload: {
          data,
        },
      });
      return true;
    },
    *updateDraw({ payload }, { call, put }) {
      const { data, error } = yield call(jungleExpeditionUpdateDraw, payload);
      if (error) {
        Toast.show({
          content: error,
        });
        return error;
      }
      if (data) {
        yield put({
          type: 'updateTicketInfo',
          payload: { ...data },
        });
        return {
          success: true,
          data,
        };
      }
    },
    *updateTreasureTool({ payload }, { call, put }) {
      const { data, error } = yield call(jungleExpeditionUpdateTreasure, payload);
      if (error) {
        Toast.show({
          content: error,
        });
        return error;
      }
      yield put({
        type: 'updateSynthesisCount',
        payload: {},
      });
      return {
        success: true,
        data,
      };
    },
    *getWinList({ payload }, { call, put, select }) {
      const { winPageInfo } = yield select(state => state.activityJungleExpedition);
      const { pageNum, pageSize } = winPageInfo;
      const { error, data } = yield call(jungleExpeditionWinList, {
        ...payload,
        pageNum: payload.force ? 1 : pageNum,
        pageSize: pageSize,
        force: undefined,
      });
      // yield put({
      //   type: 'updateWinList',
      //   payload: { ...MockWinList, pageNum: payload.force ? 2 : pageNum + 1, pageSize, force: payload.force },
      // });
      // return true;
      if (error || !data) {
        yield put({
          type: 'updateWinList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateWinList',
        payload: { ...data, pageNum: payload.force ? 2 : pageNum + 1, pageSize, force: payload.force },
      });
      return true;
    },
  },
};
